import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import storage from "utils/data/storage";
import Button from "components/utils/button";
import "./index.scss";

const propTypes = { handleClose: PropTypes.func };

const InformationBooking = ({ handleClose = () => {} }) => {
  const storageData = storage.data || {};
  const {
    bookingid,
    beginat,
    programname,
    studentinfo,
    isbookingtest,
    bookinginfo,
  } = storageData?.metadata?.meta || {};

  const initializeData = (data, initData) =>
    typeof data === "string" ? JSON.parse(data) : initData;

  const isBookingTest = initializeData(isbookingtest, false);
  const bookingInfo = initializeData(bookinginfo, {});
  const studentInfoList = initializeData(studentinfo, []);

  const onViewBooking = () => {
    if (!bookingid) return;
    if (isBookingTest) {
      return window.open(
        `https://dashboard.kynaforkids.vn/booking/list/booking-test?BookingSessionSearch[booking_id]=${bookingid}`,
        "_blank"
      );
    }
    return window.open(
      `https://dashboard.kynaforkids.vn/booking/list/index?BookingSessionSearch[booking_id]=${bookingid}`,
      "_blank"
    );
  };

  const onViewInfoStudent = (userId) => {
    if (!userId) return;
    window.open(
      `https://dashboard.kynaforkids.vn/bookingstudent/booking-student/info?id=${userId}`,
      "_blank"
    );
  };

  const onViewInfoTeacher = () => {
    if (!bookingInfo?.teacherId) return;
    window.open(
      `https://dashboard.kynaforkids.vn/bookingteacher/booking-teacher/view?id=${bookingInfo?.teacherId}`,
      "_blank"
    );
  };

  const information = [
    {
      name: "Booking ID",
      value: bookingid,
      onClick: onViewBooking,
    },
    {
      name: "Class date",
      value: moment(beginat * 1000).format("DD-MM-YYYY"),
    },
    {
      name: "Lesson name",
      value: bookingInfo?.lessonName,
    },
    {
      name: "Level name",
      value: bookingInfo?.levelName,
    },
    {
      name: "Program name",
      value: programname,
    },
    {
      onClick: onViewInfoTeacher,
      name: "Teacher",
      value: `${bookingInfo?.teacherName || ""} - ${
        bookingInfo?.teacherId || ""
      }`,
    },
    {
      isList: true,
      name: "List student",
      value: studentInfoList,
    },
  ];

  return (
    <div className="information-modal">
      <div className="information-modal__body">
        <div className="information-modal__body__header">
          <div className="title">Information Booking</div>
          <Button circle handleOnClick={handleClose} icon="close" />
        </div>
        <div className="information-modal__body__content">
          {information.map((informationItem, index) => {
            const canOnClick = typeof informationItem?.onClick === "function";
            if (informationItem?.isList)
              return (
                <div className="box-information-list">
                  <div className="box-information-list__name">
                    {informationItem?.name}:
                  </div>
                  <div className="box-information-list__list">
                    {informationItem?.value.map((student, index) => (
                      <div
                        className="content"
                        key={`information-list-${index}`}
                        onClick={() => onViewInfoStudent(student?.userId)}
                      >
                        {student?.studentName || ""} -{" "}
                        {student?.studentCode || ""}
                      </div>
                    ))}
                  </div>
                </div>
              );
            return (
              <div className="box-information" key={`information--${index}`}>
                <div className="box-information__name">
                  {informationItem.name}:{" "}
                  <span
                    onClick={() => {
                      if (canOnClick) {
                        informationItem?.onClick();
                      }
                    }}
                    className={`box-information__value ${
                      canOnClick && "canOnClick"
                    }`}
                  >
                    {informationItem?.value || ""}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

InformationBooking.propTypes = propTypes;

// Avoid re-render
const areEqual = () => true;

export default React.memo(InformationBooking, areEqual);
